<template>
  <div class="container">
    <div v-if="inv"> 

      <div class="columns border-bottom-lg">
        <div class="column col-xs-12 col-md-6">
          <img v-if="brand === 'pl'" src="../../assets/pocketlegal_logo.png" alt="PocketLegal" class="invoiceLogo"/>
          <img v-if="brand === 'ie'" src="../../assets/immiexperts.png" alt="Immigration Experts" class="invoiceLogo"/>
        </div>
        <div class="column col-xs-12 col-md-6 text-right">
          <h1>Tax Invoice</h1>
          <h4>Reference: #{{inv.ref}}</h4>
        </div>
      </div>
      <div class="columns border-bottom-lg">
        <div class="column col-xs-12 col-md-6">
            Invoice date: {{date(inv.date)}}<br />
            Due date: {{due}}<br />
            Invoice status: 
            <span v-if="inv.paid" class="label label-success">Paid</span>
            <span v-else class="label label-warning">Unpaid</span>
          </div>
        
      <div class="column col-xs-12 col-md-6">       
          {{inv.business ? inv.business : inv.firstname + ' ' + inv.lastname}}<br />
          <span v-if="inv.business">Attn: {{inv.firstname}} {{inv.lastname}}</span><br />       
        </div>
      </div>
      

      <div class="border-bottom-lg">
        <div class="columns">
          <div class="column col-12">
            <h2>Description</h2> 
            <h5>{{inv.matter_desc}}</h5>
          </div>
        </div>

        <div class="columns" v-for="item in inv.items">
          <div class="column col-4">{{item.description}}</div>
          <div class="column col-8">${{c2d(item.cost)}}</div>
        </div>

        <div class="columns" v-if="inv.gst">
          <div class="column col-4">GST (10%)</div>
          <div class="column col-8">${{c2d(inv.gst)}}</div>
        </div>

        <div class="columns" v-if="inv.surcharge">
          <div class="column col-4">Surcharge (1.4%)</div>
          <div class="column col-8">${{c2d(inv.surcharge)}}</div>
        </div>

        <div class="columns"> 
          <div class="column col-4">Total</div>
          <div class="column col-8">${{c2d(inv.total)}}</div>
        </div>
      </div>

      <div class="border-bottom-lg">
        <h2>Payment Methods</h2>
        <div class="columns">
          <div class="column col-3">
            <strong>Credit Card</strong>
          </div>
          <div class="column col-9">
            <a :href="url" class="d-none showForPrint">{{url}}</a> 
            <button class="btn btn-primary hideForPrint" v-if="showPayBtn" @click="showPay = true">
              Pay now
            </button><br /><br />
          </div>

          <div class="column col-3">
            <strong>Direct Deposit</strong>
          </div>

          <div class="column col-9">     
            BSB: 032023<br />   
            Account Number: 386512<br /> 
            Account Name: Operating Account<br />    
            Bank: Westpac<br />           
            Bank Address: 547 Crown Street, Surry Hills 2001<br />   
            SWIFT: WPACAU2S<br />
            Transaction Reference: {{inv.ref}}<br /><br />
            Please email proof of payment once transferred. <br /><br />   
          </div>

          <div class="column col-3">
            <strong>Phone</strong>
          </div>
          <div class="column col-9">
            Call <span v-if="brand === 'ie'">1300 921 114</span><span v-if="brand === 'pl'">1300 921 114</span> and mention your Transaction Reference ({{inv.ref}}).
          </div>
        </div>
      </div>


      <div class="columns">
        <div class="column col-12 text-center">
          <div v-if="brand === 'pl'">
            <p><small>
            PocketLegal Pty Ltd
            162 Redfern Street
            Redfern 2016, NSW
            accounts@pocketlegal.com.au
            ABN: 12 613 908 124
            ACN: 613 908 124
            </small></p>
          </div>
          <div v-if="brand === 'ie'">
            <p><small>
            Immigration Experts
            162 Redfern Street
            Redfern 2016, NSW
            info@immiexperts.com.au
            ABN: 12 613 908 124
            ACN: 613 908 124
            </small></p>
          </div>
        </div>
      </div>



      <div class="columns border-bottom-sm hideForPrint">
        <div class="column col-12">        
          <button class="btn bg-gray" @click="print">Print this page</button>
        </div>
      </div>


      <!-- PLAN -->
      <div v-if="inv.plan" class="paymentPlanTable">
        <table class="table">
          <thead>
            <tr>
              <th colspan="3"><h4>Your payment plan</h4></th>
            </tr>
            <tr>
              <th>Monthly payment amount: ${{c2d(inv.monthly)}}</h4></th>
              <th>Remaining: ${{c2d(inv.outstanding)}}</th>
              <th></th>
            </tr>
            <tr>
              <th>Date</th>
              <th>Monthly amount</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="payment in payments(inv)">
              <td v-if="inv.last_payment">{{payment.date}}</td>
              <td v-else>Upcoming</td>
              <td>${{c2d(payment.amount)}}</td>
              <td>
                <span v-if="payment.paid" class="label label-rounded label-success">Paid</span>
                <span v-else class="label label-rounded label-warning">Scheduled</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- END PLAN -->
      
    </div>
    <!-- END INVOICE CONTENT -->

    <payment v-if="inv" :invoice="inv" :active="showPay" v-on:hide="showPay = false" v-on:payment="getInvoice"></payment>

  </div>
</template>

<script>
import axios from 'axios'
import utils from '@/components/utils'
import payment from '@/components/accounts/paymentModal'
export default {
  name: 'invoice',
  mixins: [utils],
  components: { payment },
  data () {
    return {
      inv: null,
      showPay: false,
      url: window.location.href
    }
  },
  created () {
    this.getInvoice()
  },
  computed: {
    showPayBtn () {
      let inv = this.inv
      if (!inv || inv.paid) return false
      if (inv.plan) {
        return inv.payments.length === 0 // If the plan hasn't been initiated
      }
      return true
    },
    due () {
      // Two weeks from creation
      let period = 1000 * 60 * 60 * 24 * 14
      let d = new Date(this.inv.date)
      d.setTime(d.getTime() + period)
      return d.toLocaleDateString('en-AU')
    },
    brand () {
      return this.inv.brand || 'pl'
    }
  },
  methods: {
    getInvoice () {
      // Extract the invoice id from the address
      let id = /\w{24}/.exec(window.location.toString())
      if (!id) return

      axios.get('/api/invoices/one/' + id[0]).then(res => {
        if (res.status === 200) {
          this.inv = res.data
        }
      }).catch(e => { console.log(e.response.data) })
    },
    date (d) {
      return new Date(d).toLocaleDateString('en-AU')
    },
    c2d (c) {
      return (c / 100).toFixed(2)
    },
    print () {
      window.print()
    }
  }
}
</script>

<style scoped>
a {
  color:#136efb!important
}
.container {
  width: 90%;
  max-width: 960px;
  margin-top: 1.5em;
  margin-bottom: 1.5em
}
.invoice-title {
  cursor: pointer;
}
.tile.ClientPayment {
  padding: 1em 0;
  border-bottom: 1px solid #e7e9ed
}
.table tr:last-child {
  border-bottom: none;
}
.table tr:last-child td {
  border-bottom: none;
}
.paymentPlanTable {
  background: #3fa9f512;
  border: 1px solid #3fa9f5;
  border-radius: 2px;
  margin: 2em 0;
  padding: 2em;
}
.paymentPlanTable th,
.paymentPlanTable tr,
.paymentPlanTable td {
  border-bottom: 1px solid #3fa9f5;
  border: none;
}
.invoiceLogo {
  width:25%;
  display:block;
  padding: 0 0 1em 0;
  min-width: 165px
}
.border-bottom-lg {
  border-bottom: 3px solid;
  padding: 2em 0
}
.border-bottom-sm {
  border-bottom: 1px solid;
  padding: 2em 0
}
.btn {
  border-color: #136efb;
  color: #136efb
}
.btn:hover {
  border-color: #136efb;
  color: #136efb;
}
.btn:active {
  border-color: #136efb;
  background:  #136efb;
  color: #fff
}
@media print {
  .hideForPrint {
    display: none
  }
  .showForPrint {
    display: block !important
  }
  .label.label-warning {
    background: #ccc;
    color: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// invoice.vue?3be0ddc0